// import Vue from 'vue';
import * as types from './../type';
// import store from './../index'
const state = {
  achievement:'', //业绩日期
};
const actions = {

};
const mutations = {
  [types.GET_PERFORMANCEDATE](state,res) { //业绩日期
    state.achievement = res;
  },
};
const getters = {

};
export default {
  state,
  actions,
  mutations,
  getters,
}



// WEBPACK FOOTER //
// ./src/vuex/report/performance.js